import React from 'react';

/**
 * Phase 58C — Global app footer.
 *
 * Renders on every authed page (inserted at the bottom of <AppShell>'s
 * <main> region). Light, unobtrusive type so it doesn't compete with
 * page content. All four utility links open in a new tab and point to
 * the public marketing site (single source of truth for legal +
 * support copy).
 *
 * Hidden on mobile bottom-nav viewports — the mobile bottom-nav already
 * occupies the bottom-fixed strip, so we suppress the footer below `md`
 * to avoid double chrome.
 */
const LINKS = [
  { label: 'Privacy', href: 'https://2120.money/privacy' },
  { label: 'Terms', href: 'https://2120.money/terms' },
  { label: 'Security', href: 'https://2120.money/security' },
  { label: 'Support', href: 'https://2120.money/contact' },
];

export default function AppFooter() {
  const year = new Date().getFullYear();
  return (
    <footer
      className="mt-12 pt-6 pb-4 border-t border-border/50 hidden md:block"
      data-testid="app-footer"
      role="contentinfo"
    >
      <div className="flex flex-col sm:flex-row items-center justify-between gap-2 text-[11px] text-muted-foreground/80">
        <div data-testid="app-footer-copyright">© {year} 2120.money</div>
        <nav aria-label="Footer links" className="flex items-center gap-3">
          {LINKS.map((l, i) => (
            <React.Fragment key={l.label}>
              {i > 0 && <span aria-hidden="true" className="opacity-50">•</span>}
              <a
                href={l.href}
                target="_blank"
                rel="noopener noreferrer"
                className="hover:text-foreground transition-colors"
                data-testid={`app-footer-link-${l.label.toLowerCase()}`}
              >
                {l.label}
              </a>
            </React.Fragment>
          ))}
        </nav>
      </div>
    </footer>
  );
}
